/**
 * Stable React key for a response block (Stage 2.3).
 *
 * `${type}-${index}` alone is unsafe once blocks can arrive mid-stream: a new
 * block inserted ahead of an existing one shifts every index after it, so React
 * reuses the wrong element and remounts server-driven cards. That collapses an
 * expanded confirmation card while the user is reading it, and drops any local
 * state a card holds.
 *
 * Server blocks carry their own identity, so prefer it. Index is the last
 * resort, and only for blocks that have no identity to offer.
 */
const ID_FIELDS = ['id', 'block_id', 'blockId', 'proposal_id', 'proposalId', 'review_id', 'document_id', 'path']

export function blockKey(block, index) {
  if (!block || typeof block !== 'object') return `block-${index}`

  for (const field of ID_FIELDS) {
    const value = block[field]
    if (typeof value === 'string' && value) return `${block.type}-${value}`
    if (typeof value === 'number') return `${block.type}-${value}`
  }

  return `${block.type}-${index}`
}
